import { View } from 'foundations-components/components/View';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { ThemeProvider, useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchBarInput(props) {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-default",
      borderRadius: "100",
      children: /*#__PURE__*/_jsx(TFlex, {
        align: "stretch",
        children: /*#__PURE__*/_jsx(SearchInput, Object.assign({}, props, {
          styled: false
        }))
      })
    })
  });
}